import axios, { CancelTokenSource, CancelToken } from 'axios';
import Long from 'long';
import { ITimestamp } from './proto/apiContract';

export interface IGroupedApiCtx<T> {
    api: T;
    isOpen: () => boolean;
    cancel: (message?: string) => void;
    close: () => void;
}

export interface IGroupedApi<T> {
    open: () => IGroupedApiCtx<T>;
}

const tokenizer = axios.CancelToken;

export function createGroupedApi<T>(apiFactory: (cancelToken: CancelToken) => T): IGroupedApi<T> {
    return {
        open: () => {
            let source: CancelTokenSource = tokenizer.source();
            return {
                api: apiFactory(source.token),
                isOpen: () => {
                    return source !== null;
                },
                cancel: (message?: string) => {
                    source.cancel(message);
                },
                close: () => {
                    source = null;
                }
            };
        }
    };
}

export enum SportsBettingApiResult {
    Failed = 0,
    Success = 1,
    NoChange = 2,
    SessionExpired = 3
}

export interface ISBApiOperationResponse<T> {
    Result: SportsBettingApiResult;
    TimeStamp?: number;
    ReturnValue: T
}

export interface ISBProtobufApiOperationResponse extends ISBApiOperationResponse<string> { }

export const protoUtils = {
    protoTimeStamp2Date: (ts: ITimestamp): Date => {
        if (!ts.Value) {
            return null; //TODOHX correct?
        }
        return new Date(<number>ts.Value);
    },

    protoLongNumberToNumber: (value: number | Long | null) => {
        if (value === null) {
            return null;
        }
        if (value instanceof Long) {
            return (<Long>value).toNumber();
        }
        return value;
    }
}
